import { APICore } from "./apiCore";
const api = new APICore();

const getIssueTypeList = (params)  => {
    const baseUrl = `/issue_types/list`;
    return api.get(`${baseUrl}`, params);
}

const getIssueTypeById = (params) => {
    const baseUrl = `/issue_types/get`;
    return api.get(`${baseUrl}`, params);
}

const issueTypeAdd = (params) => {
    const baseUrl = `/issue_types`;
    return api.create(`${baseUrl}`, params);
}

const issueTypeAddInstant = (params) => {
    const baseUrl = `/issue_types`;
    return api.create(`${baseUrl}`, params);
}

const issueTypeUpdate = (params) => {
    const baseUrl = `/issue_types/update`;
    return api.update(`${baseUrl}`, params);
}

const issueTypeDelete = (id) => {
    return api.delete(`/issue_types/delete/${id}`);
}

export { getIssueTypeList, getIssueTypeById, issueTypeAdd, issueTypeAddInstant, issueTypeUpdate, issueTypeDelete }